import { render } from "./AddFormBuilder.vue?vue&type=template&id=8e0e29ae&scoped=true"
import script from "./AddFormBuilder.vue?vue&type=script&lang=js"
export * from "./AddFormBuilder.vue?vue&type=script&lang=js"

import "./AddFormBuilder.vue?vue&type=style&index=0&id=8e0e29ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0e29ae"]])

export default __exports__